import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator, Text } from 'trpc-react-native-ui';
import { OptionSlider } from '../common/CharacteristicSlider';
import I18n from '../../lib/i18n';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
  },
  titleContainer: {
    alignItems: 'center',
  },
});

const ExtraSlider = props => {
  if (!props.extraTopUp.length) {
    return <ActivityIndicator />;
  }

  const options = [
    {
      id: '',
      price: 0,
      type: 'EXTRA',
      characteristic: {
        value: 0,
        unit: props.extraTopUp[0].characteristic?.unit,
      },
    },
    ...props.extraTopUp,
  ];

  return (
    <View style={styles.conainer}>
      <View style={styles.titleContainer}>
        <Text style={styles.title}>{I18n.t('setBudget')}</Text>
      </View>
      <OptionSlider
        options={options}
        onSelect={props.onSelect}
        name="EXTRA"
        selectedOptions={Object.values(props.selectedTopUps)}
        showLabel={false}
      />
    </View>
  );
};

ExtraSlider.propTypes = {
  extraTopUp: PropTypes.arrayOf(PropTypes.object),
  selectedTopUps: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
};

export default ExtraSlider;
